<template>


  <add-edit-service-template-modal
      ref="addEditModal"
      :visible="addFormVisible"
      :saving="saving"
      :sender-options="senderOptions"
      :allowed-senders-per-operator="allowedSendersPerOperator"
      @close="addFormVisible=false"
      @onSave="upsertTemplates"
  />

  <el-dialog width="100%" title="Отозвать платные шаблоны"
             v-model="revokeModalVisible" @close="revokeModalVisible = false">
    <p>В таблице отображены только активные платные шаблоны</p>
    <el-table :data="payableActiveTemplates" style="width: 100%">
      <el-table-column label="" width="30">
        <template #header>
          <input type="checkbox" v-model="selectAll" :value="true"/>
        </template>
        <template #default="scope">
          <input type="checkbox" v-model="revokeSelection" :value="scope.row.id"/>
        </template>
      </el-table-column>
      <el-table-column prop="oper_group" label="Группа операторов" width="150"/>
      <el-table-column :formatter="trafficType" label="Тип трафика" width="150"/>
      <el-table-column prop="sender_name" label="Подпись" width="150"/>
      <el-table-column label="Шаблон" min-width="300">
        <template #default="scope">
          <pre class="text-pre">{{ scope.row.template }}</pre>
        </template>
      </el-table-column>
      <el-table-column min-width="140" label="Счетчик">
        <template #default="scope">
          <el-button type="success" size="small"
                     :disabled="!scope.row.counters.length">
            {{ lastMonthCounter(scope.row) }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-button type="default" @click="revokeModalVisible = false">Отмена</el-button>
      <el-button :loading="revoking" type="danger" :disabled="!revokeSelection.length" @click="requestTemplatesRevoke">Отозвать шаблоны</el-button>
    </template>
  </el-dialog>
  <service-templates-table
      :loading="loading"
      :templates="templates"
      :small="small"
      @onAdd="showAddForm"

  >
    <template #client-extension>
      <el-button :loading="revoking" type="danger" @click="revokeModalVisible = true">Отозвать шаблоны</el-button>
    </template>
  </service-templates-table>

</template>

<script>

import ServiceTemplatesTable from "@shared/components/lk/serviceTemplates/table.component.vue";
import AddEditServiceTemplateModal from "@shared/components/lk/serviceTemplates/add-edit-modal.component.vue";
import templateTrafTypeFormatter from "@shared/mixins/templateTrafficTypeFormatter";

export default {
  name: "ClientServiceTemplatesView",
  props: ["small"],
  components: {AddEditServiceTemplateModal, ServiceTemplatesTable},
  mixins: [templateTrafTypeFormatter],
  mounted() {
    this.refresh()
  },
  watch: {
    selectAll(value) {
      if (value)
        this.revokeSelection = this.payableActiveTemplates.map(t => t.id)
      else
        this.revokeSelection = []
    }
  },
  methods: {
    refresh() {
      this.loading = true
      Promise.all([
        this.axios.get("/user/getMyServiceTemplates"),
        this.axios.get("/sender_names/profiSenderNames")
      ])
          .then(([templates, senders]) => {
            this.templates = templates.data
            this.allowedSendersPerOperator = senders.data
            this.loading = false
          })
          .catch(console.error)
    },
    upsertTemplates(addForm) {
      this.saving = true
      this.axios.post("/user/upsertServiceTemplates", addForm)
          .then(resp => {
            this.saving = false
            if (resp.data.error) {
              this.$gNotify("Такой шаблон для этой подписи уже назначен", "error")
            } else {
              this.addFormVisible = false
              this.$gNotify(`Добавлено: ${resp.data.added} | Дубли: ${resp.data.skipped}`, "success")
              this.refresh()
            }
          })
    },
    showAddForm() {
      this.$refs.addEditModal.reset()
      this.addFormVisible = true
    },
    requestTemplatesRevoke() {
      this.$confirm(
          "Выбранные активные шаблоны будут отозваны со следующего месяца. Отзыв шаблонов не гарантируется, если до окончания месяца остается менее 7 рабочих дней.",
          {confirmButtonText: "Отозвать", confirmButtonClass: "el-button--danger"}
      ).then(r => {
        if (!r) return
        this.revoking = true
        this.axios.post("/user/revokeServiceTemplates", {ids: this.revokeSelection})
            .then(resp => {
              this.revoking = false
              this.revokeModalVisible = false
              this.refresh()
            })
      }).catch(console.error)
    }
    // showEditForm(t){
    //   this.$refs.addEditModal.setEditTemplate(t).then(() => {this.addFormVisible = true})
    // },

  },
  computed: {
    senderOptions() {
      return Array.from(new Set(Object.values(this.allowedSendersPerOperator || {}).reduce((acc, v) => acc.concat(v), [])))
    },

    payableActiveTemplates() {
      return this.templates.filter(t => t.status === "active" && !t.revokeRequested && ['570e2c11b52438c11a38f99c', '570e2cb6b52438c11a38f99e', '570e2c6cb52438c11a38f99d', "570e2be8b52438c11a38f99b"].includes(t.opg_id))
    }
  },
  data() {
    return {
      loading: false,
      revoking: false,
      saving: false,
      templates: [],
      allowedSendersPerOperator: {},
      addFormVisible: false,
      revokeModalVisible: false,
      selectAll: false,
      revokeSelection: []
    }
  }
}

</script>
